import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './Contact.css';
import ContactForm from './ContactForm.js';
import { Link } from 'react-router-dom';
import { FaLinkedin } from "react-icons/fa";





function Contact() {

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
            }
        },
        { threshold: 0.1 }
    );

    if (sectionRef.current) {
        observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  
  return (
    <section id="contact" className="py-20 bg-gray-50" ref={sectionRef}>
      <div className="max-w-4xl mx-auto px-6">
          <div className={`text-center mb-16 fade-in ${isVisible ? 'visible' : ''}`}>
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Let's Discuss Your Next Project</h2>
              <p className="text-xl text-gray-600">Ready to drive results through strategic project management</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
              <div className={`fade-in ${isVisible ? 'visible' : ''}`}>
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">Get In Touch</h3>
                  <div className="space-y-6">
                      <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                              <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                              </svg>
                          </div>
                          <div>
                              <h4 className="font-semibold text-gray-800">Email</h4>
                              <p className="text-gray-600">summ.flowers@gmail.com</p>
                          </div>
                      </div>
                      {/* <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                              </svg>
                          </div>
                          <div>
                              <h4 className="font-semibold text-gray-800">Phone</h4>
                              <p className="text-gray-600">+1 (555) 987-6543</p>
                          </div>
                      </div> */}
                      <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                              </svg>
                          </div>
                          <div>
                              <h4 className="font-semibold text-gray-800">Location</h4>
                              <p className="text-gray-600">Houston, TX</p>
                          </div>
                      </div>
                      <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center">
                              {/* <svg className="w-6 h-6 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                              </svg> */}
                            <FaLinkedin className="text-indigo-600 text-m" />
                          </div>
                          <div>
                              <h4 className="font-semibold text-gray-800">LinkedIn</h4>
                              <Link to="https://www.linkedin.com/in/summerflowers/" target="_blank" rel="noopener noreferrer" className="text-gray-600">linkedin.com/in/summerflowers</Link>
                          </div>
                      </div>
                  </div>
              </div>

              <div className={`fade-in ${isVisible ? 'visible' : ''}`}>
                  <ContactForm />
              </div>
          </div>
      </div>
    </section>
  );
}

export default Contact;